import { GridOptions, ProcessCellForExportParams } from 'ag-grid-community'
import { useCallback } from 'react'
import { exportExcel } from '../../../containers/BulkSheet/excel'
import { AggregateField } from '../../../../domain/entity/WbsItemEntity'

const PROGRESS_COLUMNS = [
  'total',
  'scheduledToBe',
  'completed',
  'preceding',
  'delayed',
  'remaining',
  'unplanned',
]

const EVM_COLUMNS = [
  'actualHour',
  'costVariance',
  'scheduleVariance',
  'estimateToComplete',
  'estimateAtCompletion',
  'varianceAtCompletion',
]

export const useExcel = (gridOptions: GridOptions) => {
  const customExportValues = useCallback(
    (params: ProcessCellForExportParams): string | undefined => {
      if (!params.node) return undefined
      const colId = params.column.getColId()
      const hoursPerUnit =
        params.context?.workloadUnitState?.hoursPerSelectedUnit || 1

      if (PROGRESS_COLUMNS.includes(colId)) {
        if (
          params.context?.aggregateField !== AggregateField.WBS_ITEM_WORKLOAD
        ) {
          return undefined
        }
        if (params.value === undefined || params.value === null) {
          return undefined
        }
        return (Number(params.value) / hoursPerUnit).toFixed(1)
      }

      if (EVM_COLUMNS.includes(colId)) {
        if (params.value === undefined || params.value === null) {
          return undefined
        }
        return (Number(params.value) / hoursPerUnit).toFixed(1)
      }

      return undefined
    },
    []
  )

  const onExportExcel = useCallback(
    (colIds: string[]) => {
      if (!colIds || colIds.length === 0) return
      exportExcel({
        fileNamePrefix: 'project_overview',
        gridOptions,
        exportColIds: colIds,
        shouldRowBeSkipped: params =>
          !params.node.data.progress || !params.node.displayed,
        getCustomExportValue: customExportValues,
      })
    },
    [gridOptions, customExportValues]
  )

  return { onExportExcel }
}
